import axios from 'axios';
import { ElMessage } from 'element-plus';
// import 'element-ui/lib/theme-chalk/message.css'
// import 'element-ui/lib/theme-chalk/message-box.css'
import store from '@/store/index';
import router from '@/router';
import { getScreenToken, getKey } from '../utils/auth';
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 25000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers['token'] = getScreenToken();
      config.headers['key'] = getKey();
    }
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status !== 200) {
      return Promise.reject(new Error(response.message || 'Error'));
    } else {
      if (res.code === 200 || res.code === 0) {
        store.dispatch('SET_IS_LOADING', true);
        return res;
      } else if (res.code === 401) {
        ElMessage({
          message: res.detail,
          type: 'error',
        })
        const error = new Error(res.detail)
        return Promise.reject(error);
      } else if (res.code == 412) {
        ElMessage({
          message: '登录超时,请重新登录',
          type: 'warning',
        });
        router.push('/login');
        // return Promise.reject(new Error(res.message || 'Error'));
      } else {
        // console.log(res)
        store.dispatch('SET_IS_LOADING', false);
        // return Promise.reject(new Error(res.message || 'Error'));
      }
    }
  },
  (error) => {
    // console.log(44444)
    if (error.toString().indexOf('401') !== -1) {
      router.push('/login');
      store.dispatch('SET_IS_LOADING', false);
      // store.dispatch('GET_SCREEN_TOKEN')
      // console.log(error)
      // MessageBox.confirm('登录超时,请重新登录', {
      //   confirmButtonText: '登录',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   router.push('/login')
      // })
    }
    return Promise.reject(error)
    // return Promise.reject(error);
  }
);

export default service;
